<template>
  <div class="info">
    <bread-list-new
      :routeQuery="routeQuery"
      v-if="
        this.routeQuery.clubtype == 'club' || this.routeQuery.clubtype == 'team'
      "
    ></bread-list-new>
    <bread-list :routeQuery="routeQuery" v-else></bread-list>

    <article-template></article-template>
  </div>
</template>
<script>
import BreadList from '../../components/BreadList/index.vue'
import BreadListNew from '../../components/BreadList/indexnew.vue'
import ArticleTemplate from '../../components/ArticleTemplate/index.vue'
export default {
  name: 'Info',
  components: {
    BreadList,
    ArticleTemplate,
    BreadListNew,
  },
  data() {
    return {
      routeQuery: '',
    }
  },
  created() {
    this.routeQuery = this.$route.query
  },
}
</script>
<style lang="scss" scoped>
.info {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
</style>
